import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=61ee9fd0&scoped=true"
import script from "./ConfigList.vue?vue&type=script&lang=js"
export * from "./ConfigList.vue?vue&type=script&lang=js"
import style0 from "./ConfigList.vue?vue&type=style&index=0&id=61ee9fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ee9fd0",
  null
  
)

export default component.exports